package org.braunequip.web.components.forms

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.functions.min
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaX
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.browser.document
import org.braunequip.web.components.models.DieselFuelLogDTO
import org.braunequip.web.components.models.DieselType
import org.braunequip.web.components.widgets.ConfirmModal
import org.braunequip.web.util.Constants.FONT_FAMILY2
import org.braunequip.web.util.InputIDs
import org.braunequip.web.util.Theme
import org.braunequip.web.util.formatDate
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.name
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.w3c.dom.HTMLInputElement

@Composable
fun AdminDieselLogForm(
    toUpdateDieselLog: DieselFuelLogDTO? = null,
    onSubmit: (DieselFuelLogDTO) -> Unit,
    onDismiss: () -> Unit
) {
    var showConfirmModal by remember { mutableStateOf(false) }
    var errorText by remember { mutableStateOf(" ") }
    var dieselFuelLogState by remember(toUpdateDieselLog) {
        mutableStateOf(
            toUpdateDieselLog?.copy() ?: DieselFuelLogDTO()
        )
    }

    LaunchedEffect(Unit) {
        //Necessary for loading default value, and having it still be editable.
        val dieselClearCheck = (document.getElementById(InputIDs.DieselLogForm.dieseltypeClear) as HTMLInputElement)
        val dieselDyeCheck = (document.getElementById(InputIDs.DieselLogForm.dieseltypeDyed) as HTMLInputElement)
        dieselClearCheck.checked = (dieselFuelLogState.dieselType == DieselType.clear)
        dieselDyeCheck.checked = (dieselFuelLogState.dieselType == DieselType.dyed)

    }

    Box(
        modifier = Modifier
            .width(100.vw)
            .height(100.vh)
            .position(Position.Absolute)
            .top(0.px)
            .left(0.px)
            .zIndex(19),
        contentAlignment = Alignment.TopCenter
    ) {
        Column(
            modifier = Modifier
                .backgroundColor(Colors.White)
                .borderRadius(20.px)
                .margin(top = 4.cssRem)
                .padding(1.cssRem)
                .zIndex(20)
                .width(min(500.px, 100.percent - 2.cssRem)),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Top
        ) {
            Row(
                modifier = Modifier
                    .fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {

                SpanText(
                    text = "ID: ${dieselFuelLogState.id}",
                    modifier = Modifier
                        .fontSize(1.cssRem)
                        .fontFamily(FONT_FAMILY2)
                )


                FaX(
                    modifier = Modifier
                        .cursor(Cursor.Pointer)
                        .onClick {
                            onDismiss()
                        }
                        .color(Colors.Grey)
                )
            }

            /* Specific Form Rows Here */
            Row(
                modifier = Modifier
                    .margin(topBottom = 12.px)
                    .fillMaxWidth()
                    .gap(20.px)
            ) {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                ) {
                    SpanText(
                        text = "Diesel Type *",
                        modifier = Modifier
                            .margin(right = 10.px)
                            .fontWeight(FontWeight.Bold)
                    )


                    Row(
                        modifier = Modifier
                            .fillMaxWidth(),
                        horizontalArrangement = Arrangement.Start,
                        verticalAlignment = Alignment.CenterVertically
                    )  {
                        Input(
                            type = InputType.Radio,
                            attrs = Modifier
                                .id(InputIDs.DieselLogForm.dieseltypeDyed)
                                .margin(right = 15.px)
                                .height(20.px)
                                .border(
                                    width = 1.px,
                                    style = LineStyle.Solid,
                                    color = Colors.Black
                                )
                                .toAttrs {
                                    attr("placeholder", "")
                                    name(InputIDs.DieselLogForm.dieselName)
                                    value(DieselType.dyed.toString())
                                    onInput {
                                        dieselFuelLogState.dieselType = DieselType.dyed
                                    }
                                }

                        )

                        Label(
                            forId = InputIDs.DieselLogForm.dieseltypeDyed,
                            attrs = Modifier
                                .fontFamily(FONT_FAMILY2)
                                .fontSize(16.px)
                                .toAttrs()
                        ) {
                            Text(DieselType.dyed.toString())
                        }
                    }

                    Row(
                        modifier = Modifier
                            .fillMaxWidth(),
                        horizontalArrangement = Arrangement.Start,
                        verticalAlignment = Alignment.CenterVertically
                    )  {
                        Input(
                            type = InputType.Radio,
                            attrs = Modifier
                                .id(InputIDs.DieselLogForm.dieseltypeClear)
                                .margin(right = 15.px)
                                .height(20.px)
                                .border(
                                    width = 1.px,
                                    style = LineStyle.Solid,
                                    color = Colors.Black
                                )

                                .toAttrs {
                                    attr("placeholder", "")
                                    name(InputIDs.DieselLogForm.dieselName)
                                    value(DieselType.clear.toString())
                                    onInput {
                                        dieselFuelLogState.dieselType = DieselType.clear
                                    }
                                }
                        )

                        Label(
                            forId = InputIDs.DieselLogForm.dieseltypeClear,
                            attrs = Modifier
                                .fontFamily(FONT_FAMILY2)
                                .fontSize(16.px)
                                .toAttrs()
                        ) {
                            Text(DieselType.clear.toString())
                        }
                    }
                }
            }

            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .gap(20.px)
            ) {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                ) {
                    SpanText(
                        text = "Name*",
                        modifier = Modifier
                            .margin(right = 10.px)
                            .fontWeight(FontWeight.Bold)
                    )

                    Input(
                        type = InputType.Text,
                        attrs = Modifier
                            .id(InputIDs.DieselLogForm.name)
                            .fillMaxWidth()
                            .height(54.px)
                            .margin(topBottom = 12.px)
                            .padding(leftRight = 20.px)
                            .backgroundColor(Theme.LightGray.rgb)
                            .borderRadius(r = 4.px)
                            .border(
                                width = 1.px,
                                style = LineStyle.Solid,
                                color = Colors.Black
                            )
                            .fontFamily(FONT_FAMILY2)
                            .fontSize(16.px)
                            .toAttrs {
                                attr("placeholder", "")
                                attr("value", dieselFuelLogState.name) // Set value from DTO
                            }
                    )
                }

            }

            Row(
                modifier = Modifier
                    .fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                ) {
                    SpanText(
                        text = "Date*",
                        modifier = Modifier
                            .margin(right = 10.px)
                            .fontWeight(FontWeight.Bold)
                    )

                    Input(
                        type = InputType.Date,
                        attrs = Modifier
                            .id(InputIDs.DieselLogForm.date)
                            .fillMaxWidth()
                            .height(54.px)
                            .margin(topBottom = 12.px)
                            .padding(leftRight = 20.px)
                            .backgroundColor(Theme.LightGray.rgb)
                            .borderRadius(r = 4.px)
                            .border(
                                width = 1.px,
                                style = LineStyle.Solid,
                                color = Colors.Black
                            )
                            .fontFamily(FONT_FAMILY2)
                            .fontSize(16.px)
                            .toAttrs{
                                attr("value", dieselFuelLogState.date) // Set value from DTO
                            }
                    )
                }
            }

            Row(
                modifier = Modifier
                    .fillMaxWidth()
            ) {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                ) {
                    //TODO change this to a dropdown of available assets once available?
                    SpanText(
                        text = "Equipment ID*",
                        modifier = Modifier
                            .margin(right = 10.px)
                            .fontWeight(FontWeight.Bold)
                    )

                    Input(
                        type = InputType.Text,
                        attrs = Modifier
                            .id(InputIDs.DieselLogForm.equipmentid)
                            .fillMaxWidth()
                            .height(54.px)
                            .margin(topBottom = 12.px)
                            .padding(leftRight = 20.px)
                            .backgroundColor(Theme.LightGray.rgb)
                            .borderRadius(r = 4.px)
                            .border(
                                width = 1.px,
                                style = LineStyle.Solid,
                                color = Colors.Black
                            )
                            .fontFamily(FONT_FAMILY2)
                            .fontSize(16.px)
                            .toAttrs {
                                attr("placeholder", "Truck 23, Water Truck 1, Pickup 3, etc.")
                                attr("value", dieselFuelLogState.equipmentId) // Set value from DTO
                            }
                    )
                }
            }


            Row(
                modifier = Modifier
                    .fillMaxWidth()
            ) {
                Column(
                    modifier = Modifier
                        .fillMaxWidth(),
                    horizontalAlignment = Alignment.Start
                ) {
                    SpanText(
                        text = "Starting Meter *",
                        modifier = Modifier
                            .margin(right = 10.px)
                            .fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "(small total gallon number below meter)",
                        modifier = Modifier
                            .margin(right = 10.px)
                            .fontWeight(FontWeight.Light)
                    )

                    Input(
                        type = InputType.Number,
                        attrs = Modifier
                            .id(InputIDs.DieselLogForm.startingmeter)
                            .height(54.px)
                            .width(250.px)
                            .margin(topBottom = 12.px)
                            .padding(leftRight = 20.px)
                            .backgroundColor(Theme.LightGray.rgb)
                            .borderRadius(r = 4.px)
                            .border(
                                width = 1.px,
                                style = LineStyle.Solid,
                                color = Colors.Black
                            )
                            .fontFamily(FONT_FAMILY2)
                            .fontSize(16.px)
                            .toAttrs{
                                placeholder("ex. 23")
                                attr("value", dieselFuelLogState.startingMeter.toString()) // Set value from DTO
                            }
                    )

                }
            }

            Row(
                modifier = Modifier
                    .fillMaxWidth()
            ) {
                Column(
                    modifier = Modifier
                        .fillMaxWidth(),
                    horizontalAlignment = Alignment.Start
                ) {
                    SpanText(
                        text = "Ending Meter *",
                        modifier = Modifier
                            .margin(right = 10.px)
                            .fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "(small total gallon number below meter)",
                        modifier = Modifier
                            .margin(right = 10.px)
                            .fontWeight(FontWeight.Light)
                    )

                    Input(
                        type = InputType.Number,
                        attrs = Modifier
                            .id(InputIDs.DieselLogForm.endingmeter)
                            .height(54.px)
                            .width(250.px)
                            .margin(topBottom = 12.px)
                            .padding(leftRight = 20.px)
                            .backgroundColor(Theme.LightGray.rgb)
                            .borderRadius(r = 4.px)
                            .border(
                                width = 1.px,
                                style = LineStyle.Solid,
                                color = Colors.Black
                            )
                            .fontFamily(FONT_FAMILY2)
                            .fontSize(16.px)
                            .toAttrs{
                                placeholder("ex. 23")
                                attr("value", dieselFuelLogState.endingMeter.toString()) // Set value from DTO
                            }
                    )

                }
            }

            Row(
                modifier = Modifier
                    .fillMaxWidth()
            ) {
                Column(
                    modifier = Modifier
                        .fillMaxWidth(),
                    horizontalAlignment = Alignment.Start
                ) {
                    SpanText(
                        text = "Total Gallons",
                        modifier = Modifier
                            .margin(right = 10.px)
                            .fontWeight(FontWeight.Bold)
                    )

                    Input(
                        type = InputType.Number,
                        attrs = Modifier
                            .id(InputIDs.DieselLogForm.totalgallons)
                            .height(54.px)
                            .width(250.px)
                            .margin(topBottom = 12.px)
                            .padding(leftRight = 20.px)
                            .backgroundColor(Theme.LightGray.rgb)
                            .borderRadius(r = 4.px)
                            .border(
                                width = 1.px,
                                style = LineStyle.Solid,
                                color = Colors.Black
                            )
                            .fontFamily(FONT_FAMILY2)
                            .fontSize(16.px)
                            .toAttrs{
                                placeholder("ex. 23")
                                attr("value", dieselFuelLogState.totalGallons.toString()) // Set value from DTO
                            }                    )

                }
            }

            Column(
                modifier = Modifier
                    .fillMaxWidth(),
                horizontalAlignment = Alignment.Start,
            ) {
                SpanText(
                    text = "Signature:",
                    modifier = Modifier
                        .margin(right = 10.px)
                        .fontWeight(FontWeight.Bold)
                )
                Box(
                    modifier = Modifier
                        .fillMaxSize(),
                    contentAlignment = Alignment.Center
                ) {
                    dieselFuelLogState.signature?.let {
                        Img(
                            src = it,
                            alt = "Employee Signature",
                            attrs = Modifier
                                .maxWidth(150.px)
                                .maxHeight(150.px)
                                .toAttrs()
                        )
                    }
                }
            }

            Row(
                modifier = Modifier
                    .fillMaxWidth(),
                horizontalArrangement = Arrangement.Start,
                verticalAlignment = Alignment.CenterVertically
            ) {

                SpanText(
                    text = "Created: ${dieselFuelLogState.createdAt?.let { formatDate(it) }}",
                    modifier = Modifier
                        .fontSize(.75.cssRem)
                        .fontFamily(FONT_FAMILY2)
                )
            }


            SpanText(
                modifier = Modifier
                    .width(350.px)
                    .margin(top = 1.cssRem)
                    .fontFamily(FONT_FAMILY2)
                    .color(Colors.Black)
                    .textAlign(TextAlign.Center),
                text = errorText
            )


            SubmitButton(
                text = "SUBMIT",
                onClick = {
                    // Retrieve NUMBER input values from the HTML elements
                    val startingMeterInput = (document.getElementById(InputIDs.DieselLogForm.startingmeter) as HTMLInputElement).value
                    val endingMeterInput = (document.getElementById(InputIDs.DieselLogForm.endingmeter) as HTMLInputElement).value
                    val totalGallonsInput = (document.getElementById(InputIDs.DieselLogForm.totalgallons) as HTMLInputElement).value

                    //Convert them to int or they will be null.
                    val startingMeter = startingMeterInput.toIntOrNull()
                    val endingMeter = endingMeterInput.toIntOrNull()
                    val totalGallons = totalGallonsInput.toIntOrNull()

                    if (
                        startingMeter != null &&
                        endingMeter != null &&
                        totalGallons != null
                    ) {
                        dieselFuelLogState = dieselFuelLogState.copy(
                            dieselType = DieselType.fromLiteral((document.querySelector("input[name='dieseltypename']:checked") as HTMLInputElement).value),
                            name = (document.getElementById(InputIDs.DieselLogForm.name) as HTMLInputElement).value,
                            date = (document.getElementById(InputIDs.DieselLogForm.date) as HTMLInputElement).value,
                            equipmentId = (document.getElementById(InputIDs.DieselLogForm.equipmentid) as HTMLInputElement).value,
                            startingMeter = startingMeter,
                            endingMeter = endingMeter,
                            totalGallons = totalGallons,
                        )

                        if (
                            dieselFuelLogState.name.isNotEmpty() &&
                            dieselFuelLogState.date.isNotEmpty() &&
                            dieselFuelLogState.equipmentId.isNotEmpty() &&
                            dieselFuelLogState.signature != null
                        ) {
                            errorText = " "
                            showConfirmModal = true

                        } else {
                            errorText = "Please fill out all required fields."
                        }
                    } else {
                        errorText = "Please input valid numbers."
                    }
                }
            )

            if (showConfirmModal) {
                ConfirmModal(
                    actionText = "Update Diesel Fuel Log",
                    onConfirm = {
                        errorText = "Submitted!"
                        onSubmit(dieselFuelLogState)
                        showConfirmModal = false
                    },
                    onDismiss = {
                        showConfirmModal = false
                    }
                )
            }
        }

        Box(
            modifier = Modifier
                .fillMaxSize()
                .backgroundColor(Theme.DarkerGray.rgb)
                .position(Position.Fixed)
                .padding(top = 5.cssRem)
                .onClick {
                    onDismiss()
                }
                .zIndex(19),
            contentAlignment = Alignment.TopCenter
        )
    }
}